import Vue from 'vue';
import { abilitiesPlugin } from '@casl/vue';
import App from './App.vue';
import router from './router';
import { store } from './store';
import vuetify from './plugins/vuetify';
import http from './services/http';

Vue.config.productionTip = false;
Vue.use(abilitiesPlugin, store.getters.ability);

http.store = store;
http.token = store.state.token;
http.local = store.state.local;
http.lang = store.state.lang;
http.onError = (response) => {
  if (response.status === 403) {
    store.dispatch('forbidden', response);
    return true;
  }

  if (response.status === 401) {
    store.dispatch('sessionExpired', response);
    return true;
  }

  store.dispatch('notifications/error', response.body.message);
  return true;
};

router.beforeEach((to, from, next) => {
  if (to.path !== '/login' && store.state.token === '') {
    next('/login');
  } else {
    next();
  }
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
